import { Typography } from '@navi/web-ui/lib/primitives';
import React from 'react';
import cx from 'classnames';
import FeeWaiveInfoText from './FeeWaiveInfoText';
import { IFeeWaiveInfoBanner } from './interfaces';

const FeeWaiveInfoBanner: React.FC<IFeeWaiveInfoBanner> = ({ emiData }) => {
  const { isMaxWaived } = emiData || {};
  const textColor = isMaxWaived ? 'text-[var(--green-light-1)]' : 'text-[var(--blue-light)]';
  const backgroundColor = isMaxWaived ? 'bg-[var(--bg-green)]' : 'bg-[var(--bg-blue)]';

  return (
    <div className={cx(backgroundColor, 'flex items-center p-2.5 rounded-lg shadow-base')}>
      <Typography variant="p5" as="span" className={textColor}>
        <FeeWaiveInfoText emiData={emiData} />
      </Typography>
    </div>
  );
};

export default FeeWaiveInfoBanner;
